









































import { Component, Vue, Prop, PropSync, Watch } from 'vue-property-decorator'
import { DropDownController } from '@/services/request.service'
import { getAgencyId, getLocale } from '@/utils/utils'

@Component
export default class FeatureEditor extends Vue {
  @Prop({ default: false }) private canSelectFrame!: boolean
  @PropSync('frame', {
    type: Object,
    default: () => ({
      frameId: 0,
    }),
  })
  private frameEditor!: any
  private assessmentFrames: Array<any> = []
  private lastFrameId = 0

  private get rules(): any {
    return {
      frameId: [
        {
          required: true,
          message: this.$t('schoolMgmt.selectFrame'),
          trigger: 'change',
        },
      ],
    }
  }

  private get locale(): string {
    return getLocale()
  }

  @Watch('frameEditor', { immediate: true })
  private onFrameChange(newVal): void {
    if (!this.lastFrameId) {
      this.lastFrameId = this.frameEditor.frameId
    }
  }

  private created(): void {
    this.getAssessmentFrame()
  }

  private getAssessmentFrame(): void {
    const agencyId = parseInt(getAgencyId(), 10)
    DropDownController.getFramesUnderAgency(agencyId)
      .then(res => {
        this.assessmentFrames = res.data
      })
      .catch(err => {
        console.error(err)
      })
  }

  private changeFrame(frameId): void {
    if (this.lastFrameId && frameId !== this.lastFrameId) {
      this.$confirm({
        title: this.$tc('schoolMgmt.changeFrameTip'),
        onCancel: () => {
          this.$set(this.frameEditor, 'frameId', this.lastFrameId)
        },
      })
    }
  }
}
